import * as React from "react";
import { useStateContext } from "./state";
import { FormattedMessage } from "react-intl";
import type { DebugInferSchemaError } from "@aqora-io/aqora-data-utils";

const DebugInferSchemaError = ({
  error,
  files,
}: {
  error: DebugInferSchemaError;
  files: File[];
}) => {
  const [recordString, setRecordString] = React.useState<string>(
    JSON.stringify(error.record, null, 2),
  );
  React.useEffect(() => {
    if (files.length === 1) {
      const file = files[0];
      const slice = file.slice(
        Number(error.byte_start),
        Number(error.byte_end),
      );
      slice.text().then((text) => {
        setRecordString(text);
      });
    }
  }, [files, error.byte_start, error.byte_end]);
  return (
    <Error>
      <p>{error.message}</p>
      <p>
        <FormattedMessage
          defaultMessage="Error occured with record #{num}:"
          values={{ num: error.record_num + 1 }}
        />
      </p>
      <div className="overflow-auto p-2 bg-red-50 rounded-lg">
        <code className="whitespace-pre">{recordString}</code>
      </div>
    </Error>
  );
};

const Error = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="bg-error-100 p-3 flex flex-col gap-2 text-error-800 rounded-lg">
      {children}
    </div>
  );
};

export const Errors = () => {
  const {
    inferError,
    debugInferError,
    recordBatchesError,
    uploadError,
    files,
  } = useStateContext();
  if (!(inferError || debugInferError || recordBatchesError || uploadError)) {
    return null;
  }
  return (
    <div>
      {inferError && (
        <Error>
          <p>{inferError.message}</p>
        </Error>
      )}
      {debugInferError && (
        <DebugInferSchemaError files={files} error={debugInferError} />
      )}
      {recordBatchesError && (
        <Error>
          <p>{recordBatchesError.message}</p>
        </Error>
      )}
      {uploadError && (
        <Error>
          <p>{uploadError.message}</p>
        </Error>
      )}
    </div>
  );
};
